// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"20":"records-index","57":"index","580":"records-id-index"}[chunkId] + "." + {"20":"aa0f085c","57":"e30b835d","580":"1bdf9108"}[chunkId] + ".css";
};